import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { api } from "./api";
import { User } from "./types";

export type AuthSliceState = {
  token?: string;
  refreshToken?: string;
  user?: User;
};
const initialState: AuthSliceState = {};
export const logout = createAction<void>("logout");

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthenticationToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setRefreshToken(state, action: PayloadAction<string>) {
      state.refreshToken = action.payload;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        state.token = undefined;
        state.refreshToken = undefined;
        state.user = undefined;
      })
      .addCase(PURGE, (state, action) => {
        state.token = undefined;
        state.refreshToken = undefined;
        state.user = undefined;
      })
      .addMatcher(api.endpoints.signIn.matchFulfilled, (state, action) => {
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.user = undefined;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setAuthenticationToken, setRefreshToken, setUser } =
  authSlice.actions;

export default authSlice;
